<template>
    <form-view class="ar-template-view">
        <veui-steps v-if="stepsData.length" :steps="stepsData"  :current="1"/>
        <div class="template-container">
            <div class="template-item" :key="index" v-for="(item, index) in store.templateList">
                <div class="title">
                    <p>{{item.title}}</p>
                </div>
                <div class="content">
                    <muse-video v-if="item.videoUrl" :src="item.videoUrl | https"/>
                    <img v-if="item.imageUrl" :src="item.imageUrl | https" alt="AR模板" />
                </div>
                <div class="button">
                    <veui-button ui="primary" @click="useTemplate(item.id, item.from)">立即使用</veui-button>
                </div>
            </div>
        </div>
        <div class="pagination-container">
            <veui-pagination
                ui="full"
                :page-size="5"
                :page="store.page"
                :total="store.total"
                @redirect="handleRedirect"
                :page-sizes="store.pageSizes"/>
        </div>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import {Steps, Button, Pagination} from 'veui';
import createView from '@baidu/ve-ria/views/createView';
import TemplateFormModel from './TemplateFormModel';
import Video from '@/common/components/media/Video';

export default createView(FormView, TemplateFormModel, {
    name: 'TemplateFormView',
    computed: {
        prefix() {
            return this.store.isAdmin ? '' : '/app';
        }
    },
    methods: {
        // 只有 material 类型的 ar 在 copy 和 edit 时可以重新选择模板，因此有以下两种情况
        // 如果当前不是 create 页面，若选择的是不同类型模板，则直接进入 /case/create 页面,
        // 若选择的是同类型模板，且 id 相同，则进入 /material/copy 或 material/edit 路由，
        // 若 id 不同，则进入/material/create
        // 如果当前是 create 页面, 否则进入 /material/create 或 /case/create
        async useTemplate(id, from) {
            const nextPageType = this.store.type;
            const tip = this.getTip(nextPageType);
            const serviceId = this.$route.params.serviceId;
            const type = from === 'dumix' ? 'material' : 'case';
            const originalTempId = this.$route.query.templateId;
            let url = `${this.prefix}/service/${serviceId}/ar/${type}`;

            if (this.store.type === 'create') {
                url = `${url}/create?templateId=${id}&from=${nextPageType}`;
            }
            else {
                // 选择了不同类型的模板
                if (from !== 'dumix') {
                    url = `${this.prefix}/service/${serviceId}/ar/case/create?templateId=${id}&from=create`;
                }
                else {
                    // 选择了同一个模板
                    if (String(id) === String(originalTempId)) {
                        url = `${url}/${nextPageType}?templateId=${id}&from=${nextPageType}`;
                    }
                    else { // 选择了同类型的不同 id 的模板
                        const hasConfirm = await this.waitConfirm(tip, '请确认');
                        if (hasConfirm) {
                            this.global.redirect({
                                url: `${url}/copy?templateId=${id}&from=copy`,
                                type: 'push'
                            });
                        }
                        return;
                    }
                }
            }
            this.global.redirect({url, type: 'push'});
        },
        getTip(nextType) {
            if (nextType === 'copy') {
                return '选择的模板与复制的物料不一致，物料数据将无法复制，请确认';
            }
            else if (nextType === 'edit') {
                return '选择的模板与原来的物料不一致，物料数据将无法回填，请确认';
            }
            return '';
        },
        handleRedirect(page) {
            this.store.page = page;
            this.store.getTemplateList();
        }
    },
    components: {
        'veui-steps': Steps,
        'veui-button': Button,
        'veui-pagination': Pagination,
        'muse-video': Video
    },
    data() {
        return {
            stepsData: [
                {
                    label: '填写基本信息'
                },
                {
                    label: '选择AR模板'
                },
                {
                    label: '配置AR物料'
                },
                {
                    label: '预览AR物料'
                }
            ]
        };
    },
    created() {
        this.store.getTemplateList();
    }
});
</script>

<style lang="less">
.ar-template-view {
    .veui-steps-step {
        margin-right: 100px;

        &:after {
            width: 90px;
            right: -95px;
        }
    }

    .template-container {
        .template-item {
            margin: 0 20px;
            display: inline-block;

            .title {
                vertical-align: middle;
            }

            .content {
                width: 320px;
                height: 460px;
                border: 1px solid #ccc;

                img, video {
                    width: 100%;
                    height: 100%;
                }

                .muse-video {
                    width: 100%;
                    height: 100%;
                }
            }

            .button {
                margin-top: 10px;
                text-align: center;
            }
        }
    }

    .pagination-container {
        float: right;
        margin-top: 20px;
    }
}
</style>


